import { render, staticRenderFns } from "./Mounting.vue?vue&type=template&id=bc11188a&lang=pug&"
import script from "./Mounting.vue?vue&type=script&lang=js&"
export * from "./Mounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports